import { createDesktopCloudApiTransport } from '@/desktop/desktopCloudTransport';
import { createSavedViewApi, savedViewApi } from '@/services/SavedViewApi';
import {
  type WorkAreaDataSourceRegistry,
  workAreaDataSourceRegistry,
} from './WorkAreaDataSourceRegistry';

export type SavedViewDataSource = Pick<
  typeof savedViewApi,
  | 'findAll'
  | 'create'
  | 'update'
  | 'remove'
  | 'reorder'
  | 'move'
  | 'createFolder'
  | 'placeBuiltIn'
  | 'resetBuiltIn'
>;

export class SavedViewDataSourceRegistry {
  private readonly desktopCloudSources = new Map<string, SavedViewDataSource>();

  constructor(
    private readonly workAreaRegistry: WorkAreaDataSourceRegistry = workAreaDataSourceRegistry,
    private readonly cloudSource: SavedViewDataSource = savedViewApi,
    private readonly desktopCloudSourceFactory: (
      desktopWorkAreaId: string,
    ) => SavedViewDataSource = (desktopWorkAreaId) =>
      createSavedViewApi(createDesktopCloudApiTransport(desktopWorkAreaId)),
  ) {}

  forProject(projectId: string): SavedViewDataSource {
    const descriptor = this.workAreaRegistry.descriptor(projectId);
    if (!descriptor) {
      return this.cloudSource;
    }
    const desktopWorkAreaId = descriptor.desktopBinding?.desktopWorkAreaId;
    if (!desktopWorkAreaId) return this.cloudSource;
    let source = this.desktopCloudSources.get(desktopWorkAreaId);
    if (!source) {
      source = this.desktopCloudSourceFactory(desktopWorkAreaId);
      this.desktopCloudSources.set(desktopWorkAreaId, source);
    }
    return source;
  }
}

export const savedViewDataSourceRegistry = new SavedViewDataSourceRegistry();
